var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "TaxFree",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-tax-free","viewBox":"0 0 250 250"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path d="M125.1.2C56.3.2.4 56.2.4 124.9s55.9 124.7 124.7 124.7c68.7 0 124.7-55.9 124.7-124.7S193.8.2 125.1.2zm0 10c32.2 0 61.3 13.3 82.1 34.7l-78.9 66.2-6.2-16.1h-9.7L96 138.3 32.1 192c-13.7-18.9-21.7-42-21.7-67.1 0-63.2 51.4-114.7 114.7-114.7zm2.2 122.8h-9.4l7.2-6 2.2 6zm-17.7-6.1l7.8-20.7 4 10.8-11.8 9.9zm15.5 112.7c-34.6 0-65.7-15.4-86.7-39.8L92.9 154h7l3.1-8.5 5.4-4.5H130l4.8 13h9.8l-12.5-32.9 29.3-24.6 19.4 27.3-21.7 30.2h10.6l16.7-23.5L203 154h10.5l-21.6-30.3L212.3 95h-10.6l-15.4 22-15.5-22H163l50.7-42.6c16.2 19.8 25.9 45 25.9 72.5.1 63.2-51.3 114.7-114.5 114.7z"/>
  <polygon points="53,104 53,154 61,154 61,104 78,104 78,95 35,95 35,104"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/tax-free.svg